export default __webpack_public_path__ + "static/media/financialsituation3Img4.ceeef1cd.png";